"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Radio = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _Checkboxer = require("./Checkboxer.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * checkbox / radio group
 */
var CheckGroup = _antd.Checkbox.Group;
var RadioGroup = _antd.Radio.Group;

var Checkboxer = function Checkboxer(_ref) {
  var label = _ref.label,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      value = _ref.value,
      onChange = _ref.onChange,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      className = _ref.className;

  var onChangeHandle = function onChangeHandle(value) {
    onChange && onChange(value);
  };

  return /*#__PURE__*/_react.default.createElement(_Checkboxer.UiCheckboxer, {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    className: "group"
  }, /*#__PURE__*/_react.default.createElement(CheckGroup, {
    onChange: onChangeHandle,
    disabled: disabled,
    value: value
  }, options.map(function (option, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "option",
      key: index
    }, /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
      value: option.code
    }, option.name));
  }))));
};

var Radio = function Radio(_ref2) {
  var label = _ref2.label,
      _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? [] : _ref2$options,
      value = _ref2.value,
      onChange = _ref2.onChange,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      className = _ref2.className;

  var onChangeHandle = function onChangeHandle(event) {
    onChange && onChange(event.target.value, event);
  };

  return /*#__PURE__*/_react.default.createElement(_Checkboxer.UiCheckboxer, {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    className: "group"
  }, /*#__PURE__*/_react.default.createElement(RadioGroup, {
    onChange: onChangeHandle,
    disabled: disabled,
    value: value
  }, options.map(function (option, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "option",
      key: index
    }, /*#__PURE__*/_react.default.createElement(_antd.Radio, {
      value: option.code
    }, option.name));
  }))));
};

exports.Radio = Radio;
var _default = Checkboxer;
exports.default = _default;
Checkboxer.propTypes = {
  label: _propTypes.default.string,
  options: _propTypes.default.array,
  value: _propTypes.default.array,
  onChange: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  className: _propTypes.default.string
};
Radio.propTypes = {
  label: _propTypes.default.string,
  options: _propTypes.default.array,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  className: _propTypes.default.string
};